<mat-form-field class="full-width m-b-20" appearance="outline">
    <mat-label>{{pluralTitle}}</mat-label>
    <mat-chip-grid #chipGrid cdkDropList (cdkDropListDropped)="onDrop($event)"
        (cdkDropListDragStarted)="onDragStarted()" (cdkDropListDragEnded)="onDragEnded()">
        <mat-chip-row *ngFor="let pc of pcChips; let i = index" (removed)="removeChip(i, pc)" [editable]="false"
            (edited)="editChip(pc, $event)" appTouchEdit (dblclick)="handleDblClick(pc, i)"
            [matTooltip]="providerTooltip.computedTooltip" #providerTooltip="appProviderInitialsTooltip"
            [appProviderInitialsTooltip]="pc" [existingTooltip]="getTooltipText(pc)" cdkDrag
            (cdkDragStarted)="onDragStarted()" (cdkDragEnded)="onDragEnded()" [cdkDragDisabled]="!enableDragAndDrop"
            class="drag-chip">

            <!-- Drag handle icon -->
            <mat-icon *ngIf="enableDragAndDrop" cdkDragHandle class="drag-handle" [matTooltip]="'Drag to reorder'">
                {{ getDragHandleIcon() }}
            </mat-icon>

            {{ pc.code }} - {{ truncateDescription(pc.description) }}
            <button matChipRemove [attr.aria-label]="'remove ' + pc.code">
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip-row>
        <input #inputElement [placeholder]="disableAdding ? '' : 'New ' + singularTitle + '...'"
            [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" [formControl]="pcControl" [matAutocomplete]="auto" />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addChip($event.option.value)">
        <mat-option *ngFor="let code of filteredProcedureCodes | async" [value]="code">
            {{ code.code }} - {{ code.description }}
        </mat-option>
        <mat-option *ngIf="(filteredProcedureCodes | async)?.length === 0 && pcControl.value">
            Can't find the code you are looking for? <a (click)="openContactUsDialog($event)">Contact Us.</a>
        </mat-option>
    </mat-autocomplete>
    <mat-hint *ngIf="hintText && pcChips.length">{{hintText}}</mat-hint>
    <mat-hint *ngIf="enableDragAndDrop">Drag and drop to reorder codes</mat-hint>
</mat-form-field>

<ng-template #priceOverrideDialog>
    <h1 mat-dialog-title>Price Override Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Appointment Type</mat-label>
                <mat-select [(ngModel)]="codeAdditionalInfo.appointmentTypeId">
                    <mat-option *ngFor="let appointmentType of appointmentTypes"
                        [value]="appointmentType.id">{{appointmentType.type}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width" *ngIf="!codeAdditionalInfo.appointmentTypeId">
                <mat-label>Override Description</mat-label>
                <textarea matInput cdkTextareaAutosize="true"
                    [(ngModel)]="codeAdditionalInfo.overrideDescription"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Rate (ZAR)</mat-label>
                <span matPrefix>&nbsp; R&nbsp;</span>

                <input matInput [(ngModel)]="codeAdditionalInfo.priceOverride" type="number" step="0.01" required>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" [mat-dialog-close]="codeAdditionalInfo">Save</button>
    </div>
</ng-template>


<ng-template #codeTimeDialog>
    <h1 mat-dialog-title>Start/Finish Time Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>Start Time</mat-label>
                <input matInput [(ngModel)]="codeAdditionalInfo.startTime" [ngxTimepicker]="startTimePicker"
                    [format]="24" required>
                <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
                    [preventOverlayClick]="true"></ngx-material-timepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>End Time</mat-label>
                <input matInput [(ngModel)]="codeAdditionalInfo.endTime" [ngxTimepicker]="endTimePicker" [format]="24"
                    required>
                <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
                    [preventOverlayClick]="true"></ngx-material-timepicker>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="codeAdditionalInfo"
            [disabled]="!codeAdditionalInfo.startTime || !codeAdditionalInfo.endTime">Save</button>
    </div>
</ng-template>


<ng-template #codeAssistantDialog>
    <h1 mat-dialog-title>Surgical Assistant Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Assistant Name</mat-label>
                <input matInput [(ngModel)]="assistantAdditionalInfo.assistantName"
                    (ngModelChange)="filterAssistants($event)" [matAutocomplete]="assistantAuto">
                <mat-autocomplete #assistantAuto="matAutocomplete"
                    (optionSelected)="onAssistantSelected($event.option.value)">
                    <mat-option *ngFor="let assistant of filteredAssistants" [value]="assistant.name">
                        {{ assistant.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Practice Number</mat-label>
                <input matInput [(ngModel)]="assistantAdditionalInfo.assistantPracticeNumber">
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="assistantAdditionalInfo">Save</button>
    </div>
</ng-template>


<ng-template #codeBMIDialog>
    <h1 mat-dialog-title>BMI Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>Weight</mat-label>
                <input matInput [(ngModel)]="codeAdditionalInfo.weight" (input)="calculateBMI()" required>
                <span matSuffix>&nbsp; kg&nbsp;</span>
            </mat-form-field>
            <mat-form-field appearance="outline" class="m-r-10">
                <mat-label>Height</mat-label>
                <input matInput [(ngModel)]="codeAdditionalInfo.height" (input)="calculateBMI()" required>
                <span matSuffix>&nbsp; cm&nbsp;</span>
            </mat-form-field>
        </div>
        <p *ngIf="codeAdditionalInfo.BMI">Calculated BMI: {{codeAdditionalInfo.BMI}}</p>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" [mat-dialog-close]="codeAdditionalInfo">Save</button>
    </div>
</ng-template>


<ng-template #contactDialog>
    <h1 mat-dialog-title>Contact Us</h1>
    <div mat-dialog-content>
        <div class="p-t-20 field-column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Title</mat-label>
                <mat-select [(ngModel)]="contactMessage.title" required>
                    <mat-option *ngFor="let title of titles" [value]="title.value">
                        {{ title.text }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput [(ngModel)]="contactMessage.name" placeholder="Name" type="text" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Surname</mat-label>
                <input matInput [(ngModel)]="contactMessage.surname" placeholder="Surname" type="text" required>
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput [(ngModel)]="contactMessage.email" placeholder="Email" type="email" required>
            </mat-form-field>
            <app-intl-phone-input [preferredCountries]="['za']" [providedValue]="contactMessage.contactNumber"
                placeholder="Contact Number" (valueChange)="contactMessage.contactNumber = $event" name="contactNumber"
                classList="full-width"></app-intl-phone-input>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Message</mat-label>
                <textarea matInput [(ngModel)]="contactMessage.message" rows="4" required></textarea>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="sendContactMessage()">Send</button>
    </div>

</ng-template>